/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import Counselling from './../../modules/Counselling';
import Counsellor_Profile from './../../modules/Counselling/profile';
import Reports from './../../modules/Reports';
import GenerateToken from './../../modules/Generate-Token';
import Track_Bills from './../../modules/Track-Bills';
import Track_Bills_Details from './../../modules/Track-Bills/Bills-Detail';
import Dashboard from './../../modules/Dashboard';
import Counsellor_display from './../../modules/tvScreen'
import Settings from './../../modules/settings';
import Masters from './../../modules/Master';
import MasterList from '../../components/Admin/List';
import jwt from './../../services/jwt';
// import MenuItem from 'antd/lib/menu/MenuItem';
import Accesspage from './../404';
import Patients_List from '../../modules/Counselling/Patient/patients-list';
import Patient_history from '../../modules/Counselling/Patient/patient-history';
import Pending_docs from '../../modules/Counselling/Patient/pending-docs';
import Patient from '../../modules/Counselling/Patient';
import Worklist from '../../modules/Worklist';
import postService from '../../services/httpService';
import Storage from '../../services/local-store';
import Nurse_display from '../../modules/tvScreen/nurse_tv';
import New_Nurse_display from '../../modules/tvScreen/new_nurse_tv';
import NurseStation from '../../modules/tvScreen/nurse_stations';
import SignaturePage from '../../modules/Counselling/newCounsellingForms/signaturePage';
import Grafana from  '../../modules/Grafana/index';
import networkList from '../../constants/networkList';
const $ = require('jquery');
const {homepage} = networkList;
const slugswithparent = [{ "route": "add", "parent": "track-bills", "action": "add" },
{ "route": "edit", "parent": "track-bills", "action": "edit" },
{ "route": "view", "parent": "track-bills", "action": "view" },
{ "route": "add-user", "parent": "settings", "action": "add" },
{ "route": "add-doctor", "parent": "settings", "action": "add" },
{ "route": "view-user", "parent": "settings", "action": "view" },
{ "route": "edit-user", "parent": "settings", "action": "edit" },
{ "route": "view-doctor", "parent": "settings", "action": "view" },
{ "route": "edit-doctor", "parent": "settings", "action": "edit" },

{ "route": "view-role", "parent": "settings", "action": "view" },
{ "route": "edit-role", "parent": "settings", "action": "edit" },

{ "route": "user-details", "parent": "settings", "action": "view" },
{ "route": "edituser", "parent": "users", "action": "edit" },
{ "route": "add-role", "parent": "settings", "action": "add" },
{ "route": "editrole", "parent": "roles", "action": "edit" },
{ "route": "viewrole", "parent": "roles", "action": "view" },
{ "route": "counsellor-view", "parent": "counselling", "action": "add" },
{ "route": "finanical-counselling", "parent": "counselling", "action": "add" },
{ "route": "view-finanical-counselling", "parent": "counselling", "action": "view" },
{ "route": "view-document", "parent": "counselling", "action": "view" },
{ "route": "insurance-counselling", "parent": "counselling", "action": "add" },
{ "route": "view-insurance-counselling", "parent": "counselling", "action": "view" },
{ "route": "view-other-counselling", "parent": "counselling", "action": "view" },
{ "route": "counselling-print", "parent": "counselling", "action": "view" },
{ "route": "patients-history-details", "parent": "patients", "action": "view" },
{ "route": "on-bed-patient-details", "parent": "patients", "action": "view" },
{ "route": "edittvscreen", "parent": "tv-displays", "action": "edit" },
{ "route": "addradiologist", "parent": "radiologist", "action": "add" },
{ "route": "editradiologist", "parent": "radiologist", "action": "edit" },
{ "route": "viewtvscreen", "parent": "tv-displays", "action": "view" },
{ "route": "slots-add", "parent": "appointments", "action": "add" },
{ "route": "technician-view", "parent": "queue-settings", "action": "add" },
{ "route": "doctor-view", "parent": "queue-settings", "action": "add" },
{ "route": "add-counselling-stations", "parent": "settings", "action": "add" },
{ "route": "edit-counselling-stations", "parent": "settings", "action": "edit" },
{ "route": "edit-privilege", "parent": "settings", "action": "edit" },
];
class CustomPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {
        setTimeout(function () {
            if (($('.body-container').outerHeight(true) + $('header').outerHeight(true)) > $(window).height()) {
                $('footer').css({ 'position': 'relative', top: '10px' });
            } else {
                $('footer').css({ 'position': 'relative', top: 'unset' });
            }
        }, 100);
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        return prevProps;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {

        if (snapshot !== null || snapshot !== undefined) {
            if (snapshot.location.pathname !== this.props.location.pathname) { }
        }
        console.log(this.props);
        setTimeout(function () {

            if (($('.body-container').outerHeight(true) + $('header').outerHeight(true)) > $(window).height()) {
                $('footer').css({ 'position': 'relative', top: '10px' });
            } else {
                $('footer').css({ 'position': 'relative', top: '1.5pc' });
            }
        }, 100);

    }

    checkAuthToken() {
        const setHref = str => (window.location.href = str);
        const currenthref = window.location.pathname;
        const { id } = this.props.match.params

        console.log("test the refresh... CustomPage" + currenthref);
        // console.log("test the refresh... CustomPage id: " + id);
        // return   
        if (currenthref !== `${homepage}/tv-display` && currenthref !== `${homepage}/nurse-display` && currenthref !== `${homepage}/nurse-stations` && id !== 'digital-signature') {
            postService('checkAuthToken', 'GET', "").then(res => {
                if (!(res.success) && !(res.status) && (res.message === 'Token has expired')) {
                    // console.log("token service checking in....");
                    // console.log(res)
                    if (currenthref !== `${homepage}/tv-settings/start-counter` && currenthref !== '/' && currenthref !== `${homepage}/tv-screen/tv1` && currenthref !== `${homepage}/tv-screen/tv2` && currenthref !== `${homepage}/tv-screen/tv3` && currenthref !== `${homepage}/tv-screen/tv4` && currenthref !== `${homepage}/tv-screen/tv5` && currenthref !== `${homepage}/tv-screen/ramesh_tv`) {
                        Storage.clearAll();
                        setHref('/');
                    }
                }
                if (!(res.success) && !(res.status) && (res.message === 'Token is not valid')) {
                    // console.log("token service checking in....");
                    // console.log(res)
                    if (currenthref !== `${homepage}/tv-settings/start-counter` && currenthref !== '/' && currenthref !== `${homepage}/tv-screen/tv1` && currenthref !== `${homepage}/tv-screen/tv2` && currenthref !== `${homepage}/tv-screen/tv3` && currenthref !== `${homepage}/tv-screen/tv4` && currenthref !== `${homepage}/tv-screen/tv5` && currenthref !== `${homepage}/tv-screen/ramesh_tv`) {
                        // Storage.clearAll();
                        setHref('/');
                    }
                }
            });
        }
    }

    BodyRender() {
        this.checkAuthToken()
        const { id, slug } = this.props.match.params
        const { menuList } = this.props
        var page = null
        let obj = null
        // if (menuList !== undefined && menuList.length !== 0) {
        //     menuList.map((menu) => {
        //         if (id !== undefined && menu['route'] === id) {
        //             obj = menu;
        //         }
        //     })
        // }
        if (menuList.length !== 0) {
            console.log("menulist..........");
            console.log(menuList, id, slug);
            //obj = menuList.find(o => o.route === id);
            if (id !== undefined) {
                obj = menuList.find(o => {
                    if (o.route === id) {
                        if (slug !== undefined) {
                            let oscheck = o.submenu.find(os => os.route === slug);
                            if (oscheck === undefined) {
                                let osm = slugswithparent.find(sm => sm.route === slug);
                                if (osm !== undefined) {
                                    let osmcheck = o.submenu.find(os => os.route === osm.parent);
                                    if (osmcheck !== undefined) {
                                        if (osmcheck.permissions.add === 'true' && osm.action === 'add') {
                                            return o;
                                        } else if (osmcheck.permissions.edit === 'true' && osm.action === 'edit') {
                                            return o;
                                        } else if (osmcheck.permissions.view === 'true' && osm.action === 'view') {
                                            return o;
                                        }
                                    } else {
                                        if (o.permissions.add === 'true' && osm.action === 'add') {
                                            return o;
                                        } else if (o.permissions.edit === 'true' && osm.action === 'edit') {
                                            return o;
                                        } else if (o.permissions.view === 'true' && osm.action === 'view') {
                                            return o;
                                        }
                                    }
                                }
                            }
                            return oscheck;
                        } else {
                            return o;
                        }
                    }
                });
            }
        }

        console.log("test text log 1");
        let user_data = localStorage.getItem('user_data') && JSON.parse(localStorage.getItem('user_data'));
        const roleid = user_data ? user_data.roleid : '';
        if (roleid === 'RL_d4vg' || roleid === 'RL_UYUR' || roleid === 'RL_0rDv') {
            obj = {
                icon: "counselling.png",
                id: 22,
                menu_order: "4",
                permissions: {
                    add: "true",
                    delete: "true",
                    download: "true",
                    edit: "true",
                    view: "true",
                },

                route: "counselling",
                submenu: {
                    icon: "settings.png",
                    id: 27,
                    menu_order: "",
                    permissions: {
                        add: "false",
                        delete: "false",
                        download: "false",
                        edit: "false",
                        view: "true",
                    },
                    route: "counselling",
                    text: "counselling",
                },
                text: "counselling"

            }
        }
        if (id === 'login') {
            this
                .props
                .history
                .push(`/`);
        }
        if (id === 'profile') {
            page = <Counsellor_Profile  {...this.props} {...this.state} menuList={menuList} />

        }

        if (obj !== null) {
            if (obj !== undefined) {
                switch (id) {
                    case 'counselling':
                        page = <Counselling {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    case 'patients':
                        page = <Patient {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    case 'reports':
                        page = <Reports {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    // case 'track-bills':
                    //     page = <Track_Bills {...this.props} {...this.state} menuList={menuList} />;
                    //     break;
                    case 'bill-details':
                        page = <Track_Bills_Details {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    case 'dashboard':
                        page = <Dashboard {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    case 'settings':
                        page = <Settings {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    case 'master':
                        page = <Masters {...this.props} {...this.state} menuList={menuList} />;
                        break;
                    case 'generate-token':
                        page = <GenerateToken {...this.props} {...this.state} menuList={menuList} />
                        break;
                    case 'profile':
                        page = <Counsellor_Profile  {...this.props} {...this.state} menuList={menuList} />
                        break;
                    case 'worklist':
                        page = <Worklist  {...this.props} {...this.state} menuList={menuList} />
                        break;
                    // case 'bi':
                    //     page = <Grafana  {...this.props} {...this.state} menuList={menuList} />
                    //     break;  
                    case 'admissions':
                        page = <Worklist  {...this.props} {...this.state} menuList={menuList} />
                        break;
                    default:
                        page = <div></div>;
                        break;
                }
            } else {
                if (id === 'profile') {
                    page = <Counsellor_Profile {...this.props} {...this.state} menuList={menuList} />
                }
                else if (id === 'bill-details') {
                    page = <Track_Bills_Details {...this.props} {...this.state} menuList={menuList} />;
                }
                // else if (id === 'patients-history') {
                //     page = <Patient_history {...this.props} {...this.state} menuList={menuList} />;
                // }
                else if (id === 'tv-display') {
                    page = <Counsellor_display {...this.props} {...this.state} menuList={menuList} />
                }
                else if (id === 'nurse-display') {
                     page = <Nurse_display {...this.props} {...this.state} menuList={menuList} />
                    //page = <New_Nurse_display {...this.props} {...this.state} menuList={menuList} />
                }
                else if (id === 'new-nurse-display') {
                    //page = <Nurse_display {...this.props} {...this.state} menuList={menuList} />
                   page = <New_Nurse_display {...this.props} {...this.state} menuList={menuList} />
               }
                else if (id === 'nurse-stations') {
                    page = <NurseStation {...this.props} {...this.state} menuList={menuList} />
                }
                /*
                ToDo
                1. validate where id is getting from 
                2. add new condition where id eqyual to validate user
                3. show preview screen once user validates in validation screen
                4. show signature page once user accepts in preview screen
                */
                else if (id === 'digital-signature') {
                    page = <SignaturePage {...this.props} {...this.state} menuList={menuList} />
                }
                else if (id !== 'dashboard') {
                    page = <Accesspage></Accesspage>;
                }
                else {
                    let submenu = null;
                    if (menuList[0]['submenu'].length !== 0) {
                        submenu = menuList[0]['submenu'][0]['route']
                    }
                    if (submenu !== null) {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}/${submenu}`);
                    } else {
                        this
                            .props
                            .history
                            .push(`/${menuList[0]['route']}`);
                    }
                }

            }
        } else {

            if (id === 'tv-display') {
                page = <Counsellor_display {...this.props} {...this.state} menuList={menuList} />
                // page = <Nurse_display {...this.props} {...this.state} menuList={menuList} />

            }
            if (id === 'nurse-display') {
                page = <Nurse_display {...this.props} {...this.state} menuList={menuList} />
            }
            if (id === 'new-nurse-display') {
                page = <New_Nurse_display {...this.props} {...this.state} menuList={menuList} />
            }
            if (id === 'nurse-stations') {
                page = <NurseStation {...this.props} {...this.state} menuList={menuList} />
            }
            if (id === 'digital-signature') {
                page = <SignaturePage {...this.props} {...this.state} menuList={menuList} />
            }
            // page = <div> sample data</div>;
        }

        return page;
    }

    render() {
        return (
            <div className="custom-container">
                <div className="">
                    {this.BodyRender()}
                </div>
            </div>
        )
    }
}

export default jwt(CustomPage);